export default __webpack_public_path__ + "static/media/email-delivery-basic.03b2c186.png";